import { extractTokenParams } from "../tokens/recognize";

export interface TokenPreviewProps {
  raw: string;
}

/**
 * Hover-tooltip body for a configured token: the token label as a heading and one `label: value`
 * line per non-empty param. Returns null for param-less / unknown tokens (nothing to preview).
 * Resource-id params show the stored id, not a resolved name (name resolution needs async data).
 */
export const TokenPreview = ({ raw }: TokenPreviewProps) => {
  const extracted = extractTokenParams(raw);
  if (!extracted) return null;

  const { definition, values } = extracted;
  const rows = (definition.params ?? []).flatMap((param) => {
    const value = values[param.key];
    return value ? [{ key: param.key, label: param.getLabel(), value }] : [];
  });

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs font-semibold">{definition.getLabel()}</span>
      {rows.map((row) => (
        <span key={row.key} className="text-xs">
          <span className="opacity-70">{row.label}:</span> {row.value}
        </span>
      ))}
    </div>
  );
};
